import { ProductHuntDay } from "./ProductHuntDay";
import { ProductHuntVote } from "./ProductHuntVote";

export const Marketing = () => {
  return (
    <div className="flex flex-col font-lato">
      <h2 className="mb-3 text-[36px]">We Launched - And You Loved It!</h2>
      <p className="mb-5 text-[16px] font-medium">
        Our MVP debuted on Product Hunt, and we ranked #2 Product of the Day
        with over 300 upvotes!
      </p>
      <p className="mb-5 text-[16px] font-medium">
        A huge thank you to our early adopters and supporters. Your feedback is
        shaping the future of UniDeck!
      </p>
      <div className="z-10 flex gap-4">
        <a
          href="https://www.producthunt.com/posts/unideck?embed=true&utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-unideck"
          target="_blank"
        >
          <ProductHuntDay />
        </a>
        <a
          href="https://www.producthunt.com/posts/unideck?embed=true&utm_source=badge-top-post-topic-badge&utm_medium=badge&utm_souce=badge-unideck"
          target="_blank"
        >
          <ProductHuntVote />
        </a>
      </div>
    </div>
  );
};
